/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';

import withModal from '../../../../lib/withModal';
import { clearInvoiceProducts } from '../../../../actions/invoice';

import CartButton from '../../components/cart/CartButton';

const mapDispatchToProps = {
    dispatchClearProducts: clearInvoiceProducts,
};

function CartButtonContainer({ onOpen, dispatchClearProducts, ...rest }) {
    const [paid, setPaid] = useState(false);

    const onModalOpen = useCallback(() => {
        dispatchClearProducts();
        setPaid(false);
        onOpen();
    }, [dispatchClearProducts, onOpen]);

    return (
        <CartButton
            {...rest}
            paid={paid}
            setPaid={setPaid}
            onModalOpen={onModalOpen}
        />
    );
}

export default connect(
    null,
    mapDispatchToProps,
)(withModal(CartButtonContainer));
